import isNaN from 'lodash/isNaN'
import { IShipperRateTypes } from 'types/graphqlTypes'
import * as yup from 'yup'
import { REQUIRED_MESSAGE } from '../../constants'

const RATE_TYPES_VALUES = Object.values(IShipperRateTypes)
const MORE_THAN_MESSAGE = 'Must be greater than 0'
const MIN_MESSAGE = 'Must be at least 0'

export const ShipmentTermsSchemaObject = {
  /**
   * @example 1000
   */
  totalWeight: yup
    .number()
    .min(0, MIN_MESSAGE)
    .typeError(REQUIRED_MESSAGE)
    .required(REQUIRED_MESSAGE)
    .default(0),
  /**
   * @example 50
   */
  totalPallets: yup
    .number()
    .min(0, MIN_MESSAGE)
    .typeError(REQUIRED_MESSAGE)
    .required(REQUIRED_MESSAGE)
    .default(0),
  /**
   * @example 45
   */
  shipperPerMileFuelRate: yup
    .number()
    .nullable()
    .transform(val => (isNaN(val) ? null : val)),
  /**
   * @example 2600
   */
  shipperMiles: yup.number().nullable(),
  /**
   * @example 1200
   */
  shipperRate: yup
    .number()
    .moreThan(0, MORE_THAN_MESSAGE)
    .typeError(REQUIRED_MESSAGE)
    .required(REQUIRED_MESSAGE),
  /**
   * @example 'contract_backup'
   */
  shipperRateType: yup
    .mixed<IShipperRateTypes>()
    .oneOf(RATE_TYPES_VALUES, REQUIRED_MESSAGE)
    .required(REQUIRED_MESSAGE),
  /**
   * @example 'These are some special instructions for the carrier'
   */
  carrierSpecialInstructions: yup.string().nullable(),
  /**
   * @default false
   */
  team: yup.boolean().default(false),
  /**
   * @default false
   */
  floorLoaded: yup.boolean().default(false),
  /**
   * @default false
   */
  hot: yup.boolean().default(false),
  /**
   * @default false
   */
  isRelatedShipment: yup.boolean().default(false),
  /**
   * @example '123456'
   */
  originalShipmentId: yup
    .string()
    .nullable()
    .when('isRelatedShipment', {
      is: true,
      then: yup.string().required('Please select a related shipment'),
    }),
}

export const ShipmentTermsSchema = yup.object(ShipmentTermsSchemaObject)

export type TShipmentTermsSchema = yup.InferType<typeof ShipmentTermsSchema>
